// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const ShareFile = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5a.92.92 0 01.9199.9199c0 .0311-.8284 8.1814-.8284 8.1814a1 1 0 01-.9948.8987H2.905a1 1 0 01-.995-.9005l-.8-8c-.055-.5495.346-1.0396.8955-1.0945A1.002 1.002 0 012.105 5h4.9209M3 4.976V2.5C3 1.6716 3.657 1 4.4673 1h2.2119M9 3l2-2 2 2M11 1v7" /></React.Fragment>, },
  'small'
);
